/** @format */

import { WarrantiesState } from '@pdp/data-access/interfaces';
import { createReducer } from '@ngrx/store';

export const initialWarrantiesLocationState: WarrantiesState = {
	selectedWarranty: {
		displayName: '2 Year Plan'
	}
};

export const warrantiesReducer = createReducer(initialWarrantiesLocationState);
